import { ExclamationCircleOutlined } from "@ant-design/icons";
import styled from "styled-components";

export const StyledDangerIcon = styled(ExclamationCircleOutlined)`
    font-size: 24px;
    color: #bf2e2d;
    position: absolute;
    left: 17px;
    top: 17px;
`;
